module.exports = __webpack_public_path__ + "img/item1.41592ed0.png";